import { cn } from '../../lib/utils';
import { PageLoading } from './loading';

interface PageSkeletonProps {
  /** Preservado por retrocompatibilidade — ignorado a partir da migracao para o loader Untitled UI. */
  type?: 'list' | 'form' | 'detail';
  className?: string;
  /** Preservado por retrocompatibilidade — ignorado. */
  rows?: number;
  /** Mensagem opcional exibida abaixo do spinner (default: "Carregando..."). */
  message?: string;
}

/**
 * PageSkeleton — indicador de carregamento de pagina inteira.
 *
 * Historicamente montava um esqueleto de layout com <Skeleton> shadcn.
 * A partir da unificacao visual com Untitled UI, delega para o PageLoading
 * (LoadingIndicator type="dot-circle" centralizado). A assinatura publica
 * foi mantida (`type`, `rows`, `className`, `message`) para nao quebrar os
 * ~159 consumidores existentes; `type` e `rows` sao aceitos mas ignorados.
 */
export function PageSkeleton({ className, message }: PageSkeletonProps) {
  return (
    <div className={cn(className)}>
      <PageLoading message={message} />
    </div>
  );
}
